import ReactDOM from 'react-dom/client'
import { Routes } from './Routes'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { ThemeProvider } from './theme/ThemeProvider'
import { CarrinhoProvider } from './contexts/CarrinhoProvider'
import { AuthProvider } from './contexts/AuthProvider'
import * as Sentry from "@sentry/react";

let dns: string = '';
let url: string = '';

switch (import.meta.env.VITE_APP_THEME) {
  case 'AcreCap':
    dns = "https://6f3c1e73e8e154e5f980d417cc9ff066@o122481.ingest.us.sentry.io/4508438545891328";
    url = "https://lojaacrecap.progit.com.br"
    break;
  case 'MegaCap':
    dns = "https://1cbbe2840f3cb060020b55cc4bd4e9d8@o122481.ingest.us.sentry.io/4508438745251840";
    url = "https://lojamegacap.progit.com.br"
    break;
  case 'RondonCap':
    dns = "https://d59ea48cfec2a9d1e0f86f270d342edc@o122481.ingest.us.sentry.io/4508438751674368";
    url = "https://lojarondoncap.progit.com.br"
    break;
  case 'RoraiCap':
    dns = "https://fc5c5bc9ac07e20404f07cfcb6962af7@o122481.ingest.us.sentry.io/4508438755344384";
    url = "https://lojaroraicap.progit.com.br"
    break;
}

Sentry.init({
  dsn: dns,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 0.3, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [url],
  // Session Replay
  replaysSessionSampleRate: 0.8, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.3, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


ReactDOM.createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
    <ThemeProvider defaultTheme={import.meta.env.VITE_APP_THEME}>
      <AuthProvider>
        <Helmet titleTemplate='%s' />
        <CarrinhoProvider>
          <Routes />
        </CarrinhoProvider>
      </AuthProvider>
    </ThemeProvider>
  </HelmetProvider>
)
